var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7,
    fill: "#C2F764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.61987 13.5498L3.16891 11.5007L5.21795 12.0498",
    fill: "#C2F764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7818 5.95072L14.8308 6.49976L15.3799 4.45072",
    fill: "#C2F764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3397 9.67C15.1314 11.6274 14.0223 13.4617 12.187 14.5213C9.13793 16.2817 5.23904 15.237 3.47864 12.1879L3.29114 11.8631M2.6596 8.33047C2.86795 6.37305 3.97704 4.53875 5.81228 3.47918C8.8614 1.71877 12.7603 2.76347 14.5207 5.81259L14.7082 6.13735M2.61987 13.5498L3.16891 11.5007L5.21795 12.0498M12.7818 5.95072L14.8308 6.49976L15.3799 4.45072",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.dfdd2c6f.svg";
export { ForwardRef as ReactComponent };